import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiUserPlus, FiSettings, FiMap, FiMenu } = FiIcons;

const Header = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', icon: FiHome, label: 'Map' },
    { path: '/register', icon: FiUserPlus, label: 'Become an Expert' },
    { path: '/admin', icon: FiSettings, label: 'Admin Portal' },
  ];

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-white/90 backdrop-blur-lg border-b border-gray-200/50 sticky top-0 z-50"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-blue-600 rounded-xl flex items-center justify-center shadow-sm">
              <SafeIcon icon={FiMap} className="text-white text-xl" />
            </div>
            <div>
              <h1 className="text-xl font-bold gradient-text leading-tight">
                Minecraft Education Expert Network
              </h1>
              <p className="text-xs text-gray-500 font-medium tracking-wide uppercase">
                Hashemite Kingdom of Jordan
              </p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 font-medium ${
                  location.pathname === item.path
                    ? 'bg-green-100 text-green-700 shadow-sm'
                    : 'text-gray-600 hover:text-green-600 hover:bg-green-50'
                }`}
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>

          <div className="md:hidden">
            <button className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors">
              <SafeIcon icon={FiMenu} className="text-xl text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;